import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { makeStyles, Card, CardContent, Button, TextField, Grid } from '@material-ui/core';
import { GetCSRFetch } from "../../../api/msChannalApi";
import { getTips } from '../../../untils/msHelper';

function DashBoard(props) {

    const [refId, setRefId] = useState("");
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    console.log(props);
    console.log(props.Lang);
    console.log("AA testing");

    useEffect(() => {
        setErrorMsg("");
        setRefId("");
        setIsError(false);
    }, [props.Lang, props.Country]);

    useEffect(() => {  
        if(!document.querySelector("script#f8f9776f70c5")){
            includeAAScript();
        }
        
        setTimeout(() => {
            callAAScript(props.Lang);
        }, 2000);
    }, []);

    //AA integration - start
    const getOcbcData = (Lang) => {
        return  {
            "page": {
                "pageName": "hk:ocbc:business:smes:accounts:sme banking business account:enter reference number",
                "language": Lang === "zh_cn" ? "chinese" : "english", 
                "pageCategory": "pre-login application page",
                "bannerName": "",
                "channel": "accounts",
                "country": "hongkong",
                "lob": "ocbc business banking"
                },
            "product": {
                "productid": "",
                "productCategory": "smes",
                "productSubCategory": "business accounts",
                "productType": "",
                "productName": "sme banking business account"
                } ,
            "application": {
                "applicationId": "",
                "flowStep": "",
                "myInfoStatus": "",
                "flowType": "",
                "journeyName": "",
                "subJourneyName": "",
                "applicationStatus": ""
                },
            "user": {
                "CIF": "",
                "loginStatus": "pre-login",
                "authType": "non-authenticated"
                },
            "event": {
                "pageView": "true",
                "bannerImpression": "false" 
        }}
        };
    
    const includeAAScript = () => {
        const script = document.createElement("script")
        script.id = "f8f9776f70c5"
        script.src = "https://assets.adobedtm.com/f8f9776f70c5/cd7c246c20f8/launch-85be115f62b5.min.js"
        script.async = true
        document.body.appendChild(script);
    }
    
    
    const callAAScript = (Lang) => {
        try {
            if (window._satellite) {
                window.ocbcData = getOcbcData(Lang)
                console.log("OCBC Data AA :: ", window.ocbcData)
                window._satellite.track('pageView');
            }
            console.log("After calling Adobe Analytic Page View script. Check ocbcData in console!");
            
        } catch (ex) {
            console.error(ex);
            console.log("Integration for Adobe Analytic Page View fails. Check error from above log.")
        }
    
    }
    
    const callAAScriptNext = (refId) => {
        const nextOCBCData = {
            'data-ctaname':'accounts:sme banking business account:reference number next',
            'data-ctatype': 'button',
            'data-ctaposition': 'footer',
            'flowType': 'account application form',
            'productid': '',
            'productCategory': 'smes',
            'productSubCategory': 'business accounts',
            'productType': '',
            'productName': 'sme banking business account',
            'transactionId': refId?refId:'', 
            'applicationRetrieveStatus': 'rstart'};
        try {
            if (window._satellite)
                console.log("OCBC Data AA for site interaction:: ", nextOCBCData);
                window._satellite.track('siteInteraction', nextOCBCData);
                console.log("After calling Adobe Analytic next script.");
        } catch (ex) {
            console.error(ex);
            console.log("Integration for Adobe Analytic next fails. Check error from above log.")
        }
    
    }
  
    //AA integration - end

    const useStyles = makeStyles({
        item: {
            margin: "0",
            width: "100%",
            justifyContent: "center",
            display: "flex",
            marginTop: "120px",
        },
        paper: {
            maxWidth: "100%",
            marginTop: "3rem",
            marginBottom: "3rem"
            // maxHeight: "50vh",
            // width: "88.75rem",
            // height: "31.5rem",
            // margin: `${theme.spacing(1)}px auto`,
            // padding: theme.spacing(2),
        },
        CardRoot: {
            // maxWidth: "88.75rem",
            // maxHeight: "31.5rem",
            width: "88.75rem",
            height: "31.5rem",
            // position: "relative",
            "@media (max-width:1500px)": {
                marginLeft: "1rem",
                marginRight: "1rem",
                overflow: "auto"
            },
            // "@media screen and (max-width:1500px) and (min-with:800px)": {
            //     minWidth: "30.75rem",
            //     minHeight: "37.375rem",
            // }
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            // fontFamily: 'Open Sans',
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "1.5rem",
            lineHeight: "2.125rem",
            // paddingTop: "3.5rem"
        },
        msg: {
            // fontFamily: 'Open Sans',
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "1.125rem",
            lineHeight: "1.875rem"
        },
        cardContent: {
            padding: "3.75rem"
        },
        paddingDiv: {
            paddingTop: "0.625rem"
        },

        underLine: {
            paddingTop: "3.75rem",
            paddingBottom: "0.625rem",
            width: "28.75rem",
            height: "2rem",
            "@media (max-width:800px)": {
                width: "15rem"
            }
        },

        footStyle: {
            display: "flex",
            margin: "auto",
            position: "relative",
            marginBottom: "3.75rem",
            // width: "90%",
            marginTop: "3.75rem"
            // "@media (max-width:800px)": {
            //     width: "80%"
            // }
        },
        buttonStyle: {
            alignItems: "center",
            display: "flex",
            width: "100%"
        },
        submit_button: {
            background: "linear-gradient(285.23deg, #495A63 0%, #7C909B 100%);",
            color: "white",
            width: "6rem",
            height: "3.75rem",
            borderRadius: "0.375rem",
            fontSize: "1.125rem",
            fontWeight: "700",
            fontStyle: "normal",
            lineHeight: "1.4375rem",
            textAlign: "center",
            fontFamily: "unset",
            boxShadow: "0 0 0",
            "&:hover": {
                "background-color": "#008685",
                "box-shadow": "0 0 0 !important"
            },
            justifyContent: "space-evenly",
            textTransform: "unset"
        },
        text_filed: {
            '& label.Mui-focused': {
                color: 'inherit',
            },
            '& .MuiInput-underline:after': {
                // borderBottom: "2px solid #484848"
                borderBottomColor: 'inherit',
            },
            '& .MuiInput-underline.Mui-error:after': {
                borderBottomColor: "#f44336 !important",
            },
            '& .MuiFormLabel-root.Mui-error': {
                color: 'inherit',
            },
        }
    });

    const textChang = (e) => {
        if (errorMsg !== "") {
            setIsError(false);
            setErrorMsg("");
        }
        setRefId(e.target.value);
    }

    const goLink = () => {
        
        if (refId === "") {
            setIsError(true);
            setErrorMsg("Please enter Reference number.");
            return;
        } else {
            try {
                GetCSRFetch(refId).then(data => {
                    let dataObj = JSON.parse(data.data);
                    if (dataObj.status === "Success") {
                        callAAScriptNext(refId);
                        console.log(dataObj);
                        window.location.href = dataObj.data.url;
                    } else {
                        if (props.Lang && props.Lang === "zh_cn") {
                            setErrorMsg(getTips(dataObj.errorCode, "TC"));
                        } else {
                            setErrorMsg(getTips(dataObj.errorCode, "EU"));
                        }
                        setIsError(true);
                    }
                }, err => {
                    console.error("Get ID failed" + err);
                    setIsError(true);
                    setErrorMsg("We are unable to retrieve your application at the moment, please try again later.");
                })
            } catch (err) {
                console.error("Application error" + err);
                setIsError(true);
                setErrorMsg("We are unable to retrieve your application at the moment, please try again later.");
            }

        }

        setIsError(false);
        setErrorMsg("");
        console.log(refId);
    }

    const classes = useStyles();
    const bull = <span className={classes.bullet}>•</span>;
    return (
        <>
            <div className={classes.paper}>
                <Grid >
                    <Grid item className={classes.item}>
                        <Card className={classes.CardRoot} variant="outlined">
                            <CardContent className={classes.cardContent}>
                                {props.Lang && props.Lang === "zh_cn" ?
                                    <>
                                        <div className={classes.title}>
                                            請告訴我們您的參考編號
                                        </div>
                                        <div className="paddingDiv">
                                            <div className={classes.msg}>
                                                您應該從以下其中一種途徑收到您的參考編號：
                                            </div>
                                            <div style={{ paddingTop: "1.68rem" }} className={classes.msg}>
                                                <div>
                                                    {bull} 電子郵件
                                                </div>
                                                <div>
                                                    {bull} 短訊
                                                </div>
                                            </div>
                                            <div className={classes.text_filed}>
                                                <div className={classes.underLine}>
                                                    <TextField
                                                        error={isError}
                                                        label="參考編號"
                                                        fullWidth={true}
                                                        value={refId}
                                                        onChange={(e) => textChang(e)}
                                                        helperText={errorMsg}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className={classes.title}>
                                            Please tell us your reference number
                                        </div>
                                        <div className="paddingDiv">
                                            <div className={classes.msg}>
                                                You should have received your reference number from either of the following:
                                            </div>
                                            <div style={{ paddingTop: "1.68rem" }} className={classes.msg}>
                                                <div >
                                                    <span style={{ whiteSpace: "pre" }}>{bull}  An email sent to you</span>
                                                </div>
                                                <div >
                                                    <span style={{ whiteSpace: "pre" }}>{bull}  An sms sent to you</span>
                                                </div>
                                            </div>
                                            <div className={classes.text_filed}>
                                                <div className={classes.underLine}>
                                                    <TextField
                                                        error={isError}
                                                        label="Reference number"
                                                        fullWidth={true}
                                                        value={refId}
                                                        onChange={(e) => textChang(e)}
                                                        helperText={errorMsg}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>

                                }

                                <div className={classes.footStyle}>
                                    {/* <div className={classes.buttonStyle} >
                                        <Link >Back</Link>
                                    </div> */}
                                    <div>
                                        <div style={{ position: "absolute", right: "0" }}>
                                            <Button
                                                className={classes.submit_button}
                                                variant="contained"
                                                onClick={() => goLink()}
                                            >
                                                {props.Lang && props.Lang === "zh_cn" ? "下一步" : "Next"}
                                            </Button>
                                        </div>

                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default withRouter(DashBoard);